/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Apr 19 2023
 **/

import { css, Theme } from "@emotion/react";
import styled from "@emotion/styled";
import { Button, Card, Column, Grid, Row } from "@/frameworks/designStuff/components";

import { SpaceCard } from "./SpaceCard";
import { colors } from "@/styles";

//SelectSpace.tsx

export const Header = styled(Row)`
	width: 100%;
	padding-top: 28px;
	padding-bottom: 20.45px;
`;

export const CardList = styled(Grid)`
	width: 1200px;
	margin: 33.35px 60px 0;
	height: 600px;
	overflow-y: auto;
	overflow-x: hidden;

	&::-webkit-scrollbar {
		width: 10px;
	}

	&::-webkit-scrollbar-thumb {
		background: ${({ theme }) => theme.colors.neutral_50_40};
		border-radius: 5px;
		background-clip: padding-box;
		border: 2px solid transparent;
	}
	&::-webkit-scrollbar-track {
		background: white;
		background-clip: padding-box;
		-webkit-box-shadow: none;
	}
`;

export const Footer = styled(Row)`
	width: 100%;
	padding: 16px 0;
`;

export const Wrapper = styled(Column)`
	background: rgba(255, 255, 255, 0.94);
	border-radius: 12px;
	box-shadow: 0px 12px 20px 0px rgba(0, 0, 0, 0.2);
`;

//SpaceCard.tsx
export const Layout = styled(SpaceCard.Layout)<{ isCurrent?: boolean }>`
	width: 280px;
	height: 194px;
	box-shadow: ${({ isCurrent }) =>
		isCurrent ? "none" : "0px 4px 8px 0px rgba(0, 0, 0, 0.12),0px 0px 4px 0px rgba(0, 0, 0, 0.04)"};

	cursor: pointer;
`;
export const Image = styled(SpaceCard.Image)`
	width: 100%;
	display: block;
	margin-top: -9px;
`;

export const Video = styled.video`
	width: 100%;
	display: block;
	margin-top: -9px;
	position: absolute;
	top: 0;
`;
export const Content = styled(SpaceCard.Content)`
	background-color: #ffffff;
	height: 54px;
	padding: 5px 12px;
`;

export const textColorCss = (theme: Theme) => {
	return css`
		width: 100%;
		.card__title {
			color: ${theme.colors.neutral_80_100};
		}

		.card__desc {
			color: ${theme.colors.neutral_50_100};
		}
	`;
};

export const ImageWrapper = styled.div`
	height: 140px;
	overflow: hidden;
	position: relative;
`;

export const ButtonStyle = styled(Button)`
	min-width: 120px;
`;

export const Overlay = styled(Column)`
	height: 140px;
	overflow: hidden;
	position: absolute;
	top: 0;
	left: 0;
	background: ${colors.neutral_50_80};
	border-radius: inherit;
	width: 100%;
	z-index: 2;
`;
